module.exports = __webpack_public_path__ + "static/media/remove.8965f741.svg";